import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingFiscalDocumentUncancel {
  fiscalDocumentId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingFiscalDocumentUncancel = ({ fiscalDocumentId, onSuccess, onError }: UseBillingFiscalDocumentUncancel) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingFiscalDocumentUncancel', fiscalDocumentId],
    mutationFn: () => privateAxios.put(`/billing/fiscal_documents/${fiscalDocumentId}/uncancel`),
    onSuccess,
    onError,
  });
};
